import { useShop } from "../context/ShopContext";
import { formatPrice } from "../lib/constants";
import { Reveal, MaskLine } from "./Reveal";

export const Selection = () => {
  const { perfumes, collections, openPerfume } = useShop();
  const featured = perfumes.filter((p) => p.featured).slice(0, 4);
  const list = featured.length ? featured : perfumes.slice(0, 4);
  if (!list.length) return null;

  return (
    <section className="relative overflow-hidden bg-espresso py-24 sm:py-32">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-16 top-1/2 -translate-y-1/2 select-none font-serif text-[38vw] leading-none text-ivory/[0.03]"
      >
        V
      </div>
      <div className="wrap relative">
        <div className="max-w-2xl">
          <Reveal>
            <p className="eyebrow flex items-center gap-4 text-champagne">
              <span className="h-px w-10 bg-champagne" />
              La sélection de la maison
            </p>
          </Reveal>
          <MaskLine className="mt-5">
            <h2 className="font-serif text-4xl leading-[1.05] text-ivory sm:text-5xl">
              Des fragrances pensées
              <br />
              pour <em className="italic text-champagnesoft">marquer les esprits</em>
            </h2>
          </MaskLine>
        </div>

        <div className="mt-14 grid gap-x-6 gap-y-12 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((p, i) => {
            const col = collections.find((c) => (p.collections || []).includes(c.slug));
            return (
              <Reveal key={p.id || p.slug} delay={(i % 4) * 0.08}>
                <button
                  data-testid={`selection-card-${p.slug}`}
                  onClick={() => openPerfume(p)}
                  className="group block w-full text-left"
                >
                  <div className="aspect-[3/4] overflow-hidden rounded-xl bg-cocoa">
                    {p.image_url && (
                      <img
                        src={p.image_url}
                        alt={p.name}
                        loading="lazy"
                        className="h-full w-full object-cover transition-transform duration-[1200ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.05]"
                      />
                    )}
                  </div>
                  <div className="mt-5 flex items-start justify-between gap-3">
                    <div>
                      <h3 className="font-serif text-2xl leading-tight text-ivory">{p.name}</h3>
                      <p className="mt-1.5 text-[10px] uppercase tracking-[0.25em] text-champagne/80">{col?.short || col?.name}</p>
                    </div>
                    <p className="whitespace-nowrap font-serif text-lg text-champagnesoft">{formatPrice(p.price)}</p>
                  </div>
                </button>
              </Reveal>
            );
          })}
        </div>
      </div>
    </section>
  );
};
